import { Gender, type Technician } from '../types/technician/technician'

export enum PrefixType {
  THE,
  OUR,
  YOUR
}

export const getGenderedTechnician = (
  technician: Technician,
  prefixType: PrefixType
): string => {
  let title = ''

  switch (technician.gender) {
    case Gender.Male:
      switch (prefixType) {
        case PrefixType.THE:
          title = 'Der'
          break
        case PrefixType.OUR:
          title = 'Unser'
          break
        case PrefixType.YOUR:
          title = 'Ihr'
      }
      title += ' Servicetechniker'
      break
    case Gender.Female:
      switch (prefixType) {
        case PrefixType.THE:
          title = 'Die'
          break
        case PrefixType.OUR:
          title = 'Unsere'
          break
        case PrefixType.YOUR:
          title = 'Ihre'
      }
      title += ' Servicetechnikerin'
      break
    case Gender.Diverse:
    default:
      switch (prefixType) {
        case PrefixType.THE:
          title = 'Die'
          break
        case PrefixType.OUR:
          title = 'Unsere'
          break
        case PrefixType.YOUR:
          title = 'Ihre'
      }
      title += ' Technische Fachkraft'
      break
  }
  return title
}
